import { components, labelModes, services } from '@/utils'

import buttonUpDown from '@/components/button/upDown'
import generatorRow from '@/components/generator/row'
import routesFormLink from '@/components/services/routes/form/link'
import routesFormTitle from '@/components/services/routes/form/title'
import routesFormType from '@/components/services/routes/form/type'

function renderTypeField(h) {
  if (!this.type) {
    return h(
      routesFormType,
      {
        props: {
          value: this.proxy,
          serviceName: services.routingGroups
        },
        on: {
          input: event => {
            this.proxy = event
          }
        }
      }
    )
  }
}

function renderTitleField(h) {
  return h(
    routesFormTitle,
    {
      props: {
        value: this.proxy,
        serviceName: services.routingGroups
      },
      on: {
        input: event => {
          this.proxy = event
        }
      }
    }
  )
}

function renderRoutingRuleField(h, item) {
  return h(
    components.select,
    {
      props: {
        value: item.id,
        label: this.getTranslate(`${services.routingGroups}.labels.routingRule`),
        itemsDisabled: this.proxy.RoutingRules.map(({ id }) => {
          return id
        }),
        query: {
          type: this.proxy.type,
          isActive: true
        },
        service: services.routingRules,
        labelMode: labelModes.hidden,
        dense: true,
        details: false,
        clearable: true,
        autocomplete: true,
        hideSelections: true
      },
      on: {
        input: event => {
          item.id = event
        }
      }
    }
  )
}
function renderLink(h, item) {
  return h(
    routesFormLink,
    {
      props: {
        value: item,
        service: services.routingRules
      }
    }
  )
}
function renderRoutingRules(h) {
  return h(
    components.card,
    {
      class: 'grid grid-gap--8 pt-3 px-2 pb-2',
      props: {
        title: this.getTranslate(`${services.routingGroups}.subtitles.${services.routingRules}`),
        dashed: true,
        outline: true,
        rounded: true
      }
    },
    [
      h(
        generatorRow,
        {
          props: {
            value: this.proxy.RoutingRules,
            defaultValue: {
              id: undefined,
              priority: 0,
              $attach: true
            },
            sortable: true
          },
          scopedSlots: {
            row: ({ item }) => {
              return h(
                'div',
                {
                  class: 'grid grid-gap--8',
                  style: { 'grid-template-columns': '1fr auto' }
                },
                [
                  renderRoutingRuleField.call(this, h, item),
                  renderLink.call(this, h, item)
                ]
              )
            }
          },
          on: {
            input: event => {
              this.proxy.RoutingRules = event
            }
          }
        }
      )
    ]
  )
}

function renderDescriptionField(h) {
  return h(
    components.textarea,
    {
      props: {
        value: this.proxy.description,
        label: this.getTranslate(`${services.routingGroups}.labels.description`),
        grow: true,
        details: false,
        clearable: true,
        defaultValue: ''
      },
      on: {
        input: event => {
          this.proxy.description = event
        }
      }
    }
  )
}

export default function(h) {
  return h(
    components.form,
    {
      class: 'grid'
    },
    [
      renderTypeField.call(this, h),
      renderTitleField.call(this, h),
      renderRoutingRules.call(this, h),
      renderDescriptionField.call(this, h),

      h(buttonUpDown)
    ]
  )
}
